import { render } from "./Form12.vue?vue&type=template&id=5a4f87bd&scoped=true"
import script from "./Form12.vue?vue&type=script&lang=js"
export * from "./Form12.vue?vue&type=script&lang=js"

import "./Form12.vue?vue&type=style&index=0&id=5a4f87bd&scoped=true&lang=less"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4f87bd"]])

export default __exports__